import { render, staticRenderFns } from "./SystemHealth.vue?vue&type=template&id=aea0d7bc&"
import script from "./SystemHealth.vue?vue&type=script&lang=ts&"
export * from "./SystemHealth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports